<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_9855_8973)">
      <path d="M13.3333 5.33203H6.66659C5.93021 5.33203 5.33325 5.92898 5.33325 6.66536V13.332C5.33325 14.0684 5.93021 14.6654 6.66659 14.6654H13.3333C14.0696 14.6654 14.6666 14.0684 14.6666 13.332V6.66536C14.6666 5.92898 14.0696 5.33203 13.3333 5.33203Z" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M2.66659 10.6654C1.93325 10.6654 1.33325 10.0654 1.33325 9.33203V2.66536C1.33325 1.93203 1.93325 1.33203 2.66659 1.33203H9.33325C10.0666 1.33203 10.6666 1.93203 10.6666 2.66536" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_9855_8973">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#09090B'
    },
  },
};
</script>
